import * as React from 'react';
import { Fragment } from 'react';
import shouldFlipBG from '../utils/should-flip-bg';
import '../css/price-lockup.sass';

export interface PriceLockupDetails {
  label: string;
  value: string;
  description?: string;
  isNonOffer?: boolean;
}

interface PriceLockupProps {
  primaryDetails?: PriceLockupDetails[];
  secondaryDetails?: PriceLockupDetails[];
  theme?: 'night' | 'day';
  setRef?: any;
}

interface PriceLockupState {
  flipBg: string;
}

export default function PriceLockup(props: PriceLockupProps) {
  const { theme = 'day' } = props;
  const inputEl: any = React.useRef(null);
  const [state, setState] = React.useState<PriceLockupState>({
    flipBg: ''
  });

  React.useEffect(() => {
    if (state.flipBg === '' && shouldFlipBG(inputEl, theme)) {
      setState({
        ...state,
        flipBg: ' flipbg'
      });
    }
    if (props.setRef !== undefined) {
      props.setRef(inputEl);
    }
  }, []);

  const priceLockupDetails = (details: PriceLockupDetails[]) => {
    return details.map(detail => {
      return (
        <Fragment key={detail.label}>
          <div className="label">{detail.label}</div>
          <div className={`value${detail.isNonOffer ? ' strike' : ''}`}>
            {detail.value}
          </div>
          {detail.description && (
            <div className="description">{detail.description}</div>
          )}
        </Fragment>
      );
    });
  };

  return (
    <>
      {(props.primaryDetails || props.secondaryDetails) && (
        <div ref={inputEl} className={`price-lockup ${state.flipBg} ${theme}`}>
          {props.primaryDetails && (
            <div
              className={`primaryDetails${
                props.secondaryDetails && props.secondaryDetails.length
                  ? ' align'
                  : ''
              }`}
            >
              {priceLockupDetails(props.primaryDetails)}
            </div>
          )}
          {props.secondaryDetails && (
            <>
              <div className="secondaryDetails">
                {priceLockupDetails(props.secondaryDetails)}
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
}
